import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-idle-warning-dialog',
  templateUrl: './idle-warning-dialog.component.html',
  styleUrls: ['./idle-warning-dialog.component.scss']
})
export class IdleWarningDialogComponent {
  public countdown: number;

  constructor(
    private dialogRef: MatDialogRef<IdleWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { countdown: number }
  ) {
    this.countdown = data?.countdown ?? 60;
  }

  continueSession(): void {
    this.dialogRef.close('continue');
  }

  logout(): void {
    this.dialogRef.close('logout');
  }
}
